module.exports = __webpack_public_path__ + "img/account.d75552a1.svg";